var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import config from "@/config";
import CoreButton from "@/prefabs/core/Button";
import CorePanel from "@/prefabs/core/Panel";
import SplashGame from "@/lib/SplashGame";
import UtilsScreen from "@/lib/utils/screen";
var PanelRespawn = /** @class */ (function (_super) {
    __extends(PanelRespawn, _super);
    function PanelRespawn(scene, onReward) {
        var _this = this;
        var _a = UtilsScreen.safe_area(scene), y_min = _a.y_min, width = _a.width, height = _a.height;
        _this = _super.call(this, scene, width / 2, height / 2) || this;
        var i18nHandler = SplashGame.i18nHandler.getInstance();
        var rectangle = new Phaser.GameObjects.Rectangle(scene, 0, 0, width, height, 0x17171d, 0.7);
        _this.title = new Phaser.GameObjects.Text(scene, 0, 0, i18nHandler.get("panel.respawn.title"), {
            align: "center",
            fontSize: "96px",
            fontFamily: config.graphics.fontFamily,
            stroke: "#752dd3",
            strokeThickness: 16,
        }).setOrigin(0.5, 0);
        _this.subtitle = new Phaser.GameObjects.Text(scene, 0, 0, i18nHandler.get("panel.respawn.subtitle"), {
            fontFamily: config.graphics.fontFamily,
        })
            .setFontSize(36)
            .setOrigin(0.5, 0);
        _this.text_counter = new Phaser.GameObjects.Text(scene, 0, 0, "00", {
            align: "center",
            fontFamily: config.graphics.fontFamily,
        })
            .setFontSize(200)
            .setOrigin(0.5);
        _this.button_rewarded = new CoreButton(scene, 0, 0, "button.primary", "", i18nHandler.get("panel.respawn.button.revive"), -25, 36, function () {
            onReward();
            _this.button_rewarded.disableInteractive();
            _this.button_rewarded.setAlpha(0.4);
        }, 0.8, { right: "icon.ad" });
        _this.add(rectangle);
        _this.add(_this.title);
        _this.add(_this.subtitle);
        _this.add(_this.text_counter);
        _this.setDepth(99996);
        _this.setScrollFactor(0);
        _this.setVisible(false);
        return _this;
    }
    PanelRespawn.prototype.setValue = function (value) {
        this.text_counter.text = value;
    };
    PanelRespawn.prototype.setVisible = function (value) {
        var _this = this;
        var _a, _b;
        try {
            _super.prototype.setVisible.call(this, value);
            this.button_rewarded.setVisible(value);
            this.button_rewarded.setInteractive();
            this.button_rewarded.setAlpha(1);
            if (value) {
                this.setValue(config.gameplay.player.death.repeat + 1 + "");
                (_a = this.timer) === null || _a === void 0 ? void 0 : _a.destroy();
                this.timer = this.scene.time.addEvent({
                    callback: function () {
                        _this.setValue(_this.timer.getRepeatCount() + "");
                    },
                    delay: 1000,
                    repeat: config.gameplay.player.death.repeat,
                    loop: false,
                });
            }
            else {
                (_b = this.timer) === null || _b === void 0 ? void 0 : _b.destroy();
            }
        }
        catch (_c) { }
        return this;
    };
    PanelRespawn.prototype.resize = function (_width, _height) {
        var _a = UtilsScreen.safe_area(this.scene), y_min = _a.y_min, y_max = _a.y_max, width = _a.width, height = _a.height;
        var title_s_x = (_width * 0.4) / this.title.width;
        var title_s_y = (_height * 0.1) / this.title.height;
        var title_s = Math.min(title_s_x, title_s_y);
        var subtitle_s_x = (_width * 0.8) / this.subtitle.width;
        var subtitle_s_y = (_height * 0.1) / this.title.height;
        var subtitle_s = Math.min(subtitle_s_x, subtitle_s_y);
        var counter_s_x = (_width * 0.3) / this.text_counter.width;
        var counter_s_y = (_height * 0.2) / this.text_counter.height;
        var counter_s = Math.min(counter_s_x, counter_s_y);
        var button_s_x = (_width * 0.3) / this.button_rewarded.width;
        var button_s_y = (_height * 0.2) / this.button_rewarded.height;
        var button_s = Math.min(button_s_x, button_s_y);
        this.title.setScale(title_s);
        this.subtitle.setScale(subtitle_s);
        this.text_counter.setScale(counter_s);
        this.button_rewarded.setScale(button_s, button_s, true);
        this.title.y = y_min - height / 2 + config.graphics.viewbox.y;
        this.subtitle.y =
            this.title.y + this.title.displayHeight + this.subtitle.displayHeight;
        this.button_rewarded.setPosition(width / 2, y_max - this.button_rewarded.displayHeight / 2);
    };
    return PanelRespawn;
}(CorePanel));
export default PanelRespawn;
